import React from "react";
import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown-arrow.svg";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import { getKbArticles, toggleArticleFeature } from "../../../../store/features/getKbArticles";
import NoSearch from "../../../common/NoSearch";
import SearchInput from "../../../common/SearchInputField";
import SkeletonLoader from "./SkeletonLoader";

const ListPlusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 5V19" stroke="#556575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 12H19" stroke="#556575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ListCheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 6L9 17L4 12" stroke="#148DFD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);


export const AddFeaturedArticlePopup = ({ open, onClose, groupId }) => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [category, setCategory] = useState("All Categories");

    const { articles, loading, lastFetchedGroupId } = useSelector((state) => state.kbArticles);
    const business_id = useSelector((state) => state.loginToken?.response?.user?.business_id);
    const sameGroupLoaded =
        groupId != null &&
        lastFetchedGroupId != null &&
        String(lastFetchedGroupId) === String(groupId);
    const publishedArticles = articles.filter(article =>
        article.status === "Published" && article.visibility?.toLowerCase() !== "internal"
    );
    // Calculate current featured count dynamically from Redux
    const currentFeaturedCount = articles.filter(a => a.isFeatured).length;
    // Skeleton until this group's list is loaded (initial loading:true was blocking the fetch).
    const showSkeleton = !sameGroupLoaded || (loading && publishedArticles.length === 0);

    useEffect(() => {
        if (!open || !business_id || !groupId) return;
        dispatch(getKbArticles({
            business_id,
            group_id: groupId,
            page: 1,
            limit: 100,
            status: 'published',
        }));
    }, [open, business_id, groupId, dispatch]);

    const handleToggle = (article) => {
        const id = article.id || article._id;
        const isFeatured = article.isFeatured;

        if (isFeatured) {
            // Unfeature
            dispatch(toggleArticleFeature({ articleId: id, isFeatured: false, group_id: groupId }));
        } else {
            // Feature
            if (currentFeaturedCount < 6) {
                dispatch(toggleArticleFeature({ articleId: id, isFeatured: true, group_id: groupId }));
            } else {
                return;
            }
        }
    };

    const filteredArticles = publishedArticles.filter(article => {
        const matchesCategory = category === "All Categories" || article.category === category;
        const matchesSearch = (article.title || "").toLowerCase().includes(searchQuery.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    const categories = ["All Categories", ...new Set(publishedArticles.map(a => a.category).filter(c => c && c !== '-'))];

    const selectStyle = {
        borderRadius: "8px",
        borderColor: '#D5DCE1',
        background: "#FFF",
        boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
        fontSize: "14px",
        height: "40px",
        color: "#405261",
        mr: 1.5,
        '& .MuiSelect-select': { padding: '0px 16px', fontSize: 14, color: '#405261' },
        '& .MuiSelect-icon': { fontSize: 14, },
    };

    if (!open) return null;

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="overlay" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 1301 }} onClick={onClose} />

            <div className="Assign-PopUp-Container" style={{
                zIndex: 1302,
                width: '472px',
                maxWidth: '472px',
                height: '520px',
                background: '#FFF',
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                padding: '8px',
                top: 0
            }}>
                <div style={{ padding: '24px 24px 8px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                        <Typography sx={{ color: "#061522", fontFamily: "Inter", fontSize: 18, fontWeight: 500, lineHeight: "18px" }}>
                            Add Featured Articles
                        </Typography>
                        <Typography sx={{ color: "#405261", fontFamily: "Inter", fontSize: 14, fontWeight: 400, lineHeight: "22px", mt: 1 }}>
                            Select articles to feature on your help center.
                        </Typography>
                    </div>
                    <div onClick={onClose} style={{ cursor: 'pointer' }}>
                        <Close />
                    </div>
                </div>

                <div style={{ padding: "0 24px 16px 24px" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 3, mb: 0 }}>
                        <Box sx={{ flex: 1, mr: 1 }}>
                            <SearchInput
                                placeholder="Search by article title"
                                value={searchQuery}
                                className='SearchInputField-articlePopup'
                                onChange={(e) => setSearchQuery(e.target.value)}
                                noTitle
                            />
                        </Box>
                        <FormControl size="small" sx={{ ...selectStyle, width: 160, mr: 0 }}>
                            <Select
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                                IconComponent={Dropdown}
                                displayEmpty
                                sx={{ height: '40px' }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            borderRadius: "8px",
                                            boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)",
                                            border: "1px solid #D5DCE1",
                                            marginTop: "8px",
                                            '& .MuiMenuItem-root': {
                                                fontSize: "14px",
                                                fontFamily: "Inter",
                                                color: "#405261",
                                                padding: "10px 16px",
                                                '&:hover': {
                                                    backgroundColor: "#F9FAFA",
                                                    color: "#061522"
                                                },
                                                '&.Mui-selected': {
                                                    backgroundColor: "#F9FAFA",
                                                    color: "#061522",
                                                    fontWeight: 500
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                {categories.map((cat) => (
                                    <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Typography sx={{ color: "#405261", fontFamily: "Inter", fontSize: 12, fontWeight: 400, mt: 2 }}>
                        {currentFeaturedCount}/6 articles selected
                    </Typography>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', padding: "0 24px" }}>
                    {showSkeleton ? (
                        <SkeletonLoader />
                    ) : filteredArticles.length === 0 ? (
                        <NoSearch
                            title="No articles found"
                            description="Publish a public article in this group to feature it here."
                        />
                    ) : (
                        filteredArticles.map(article => {
                            const isSelected = article.isFeatured;
                            return (
                                <Box
                                    key={article.id}
                                    onClick={() => handleToggle(article)}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        py: 2,
                                        borderBottom: '1px solid #F0F4F8',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: '#F9FAFA'
                                        }
                                    }}
                                >
                                    <Box>
                                        <Typography sx={{ color: "#061522", fontFamily: "Inter", fontSize: 14, fontWeight: 400, lineHeight: "18px" }}>
                                            {article.title}
                                        </Typography>
                                        <Typography sx={{ color: "#405261", fontFamily: "Inter", fontSize: 12, fontWeight: 400, lineHeight: "18px", mt: 0.5 }}>
                                            {article.category}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        {isSelected ? (
                                            <ListCheckIcon />
                                        ) : (
                                            <ListPlusIcon />
                                        )}
                                    </Box>
                                </Box>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
}
